// extracted by mini-css-extract-plugin
module.exports = {"title":"unitHeader_title__663Fr","details":"unitHeader_details__3c5hT","CTA":"unitHeader_CTA__3bwDK","cta":"unitHeader_CTA__3bwDK","price":"unitHeader_price__2CNnj","from":"unitHeader_from__1hBqP","container":"unitHeader_container__2MjIg"};
    if(module.hot) {
      // 1745223418364
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  